import React from 'react';
import { ReactComponent as DeleteIcon } from '../../assets/images/delete.svg';
import { ReactComponent as Close } from '../../assets/images/teamclose.svg';
import './style.css';

function DeletePopUp(props) {
  const {
    onDelete,
    onCancel,
  } = props;
  return (
    <>
      <div className="overlay" />
      <div className="Team-PopUp-Container">
        <div className="Team-PopUp-Header-Group">
          <p
            className="PopUp-Text02"
            onClick={onCancel}
          >
            <Close />
          </p>
        </div>
        <div className="Delete-group-container">
          <DeleteIcon />
          <p className="DeleteFile-text">Confirm delete?</p>
          <p className="DeleteFile-text01">
            Are you sure you want to delete?
          </p>
        </div>
        <div className="Deletegroup-delete-container">
          <button
            className="Deletegroup-cancel01"
            type="button"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="Deletegroup-delete01"
            onClick={onDelete}
            type="button"
          >
            Delete
          </button>
        </div>
      </div>
    </>
  );
}

export default DeletePopUp;
